import { render, staticRenderFns } from "./applition.vue?vue&type=template&id=4265527f&"
import script from "./applition.vue?vue&type=script&lang=js&"
export * from "./applition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports